import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { applyTheme } from '@/lib/theme';
import { DEFAULT_CONTENT } from '@/data/content';
import { SiteContentProvider } from '@/context/SiteContent';
import { SiteSections } from '@/components/yunti/SiteSections';

export default function Landing() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    let mounted = true;
    api
      .get('/content')
      .then((r) => {
        if (!mounted) return;
        setContent(r.data.content);
        applyTheme(r.data.content?.theme);
      })
      .catch(() => {
        if (!mounted) return;
        setContent(DEFAULT_CONTENT);
        applyTheme(DEFAULT_CONTENT.theme);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (!content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-yunti-ground" data-testid="landing-loading">
        <span className="text-xs font-mono uppercase tracking-[0.3em] text-yunti-ink/40">YUNTI</span>
      </div>
    );
  }

  return (
    <SiteContentProvider content={content}>
      <SiteSections />
    </SiteContentProvider>
  );
}
